import { render, staticRenderFns } from "./ProfileBlock.vue?vue&type=template&id=93cb4c0e&scoped=true"
import script from "./ProfileBlock.vue?vue&type=script&lang=ts"
export * from "./ProfileBlock.vue?vue&type=script&lang=ts"
import style0 from "./ProfileBlock.vue?vue&type=style&index=0&id=93cb4c0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93cb4c0e",
  null
  
)

export default component.exports